<script setup>
import { computed, ref } from 'vue';
import HeaderPartial from '@/pages/partials/settings/headerPartial.vue';
import SectionPartial from '@/pages/partials/settings/sectionPartial.vue';
import SocialChannelCard from '@/pages/settings/components/socialChannelCard.vue';
import { useUserStore } from '@/stores/user.store.js';
import { useAppStore } from '@/stores/app.store.js';
// import { useCommonStore } from '@/stores/common.store.js'
import testSocialAvatar1 from '@/assets/test/andre-sebastian-KVDSfJ79_JU-unsplash.jpeg';
import testSocialAvatar2 from '@/assets/test/good-faces-lVhZ0aNzCWg-unsplash.jpeg';
import testSocialAvatar3 from '@/assets/test/laura-chouette-N9a5oS06Er4-unsplash.jpeg';
import testSocialAvatar4 from '@/assets/test/karsten-winegeart-TwXdXLJgv_I-unsplash.jpeg';
import testSocialAvatar5 from '@/assets/test/mike-von-BhcutpohYwg-unsplash.jpeg';
import Helpers from '@/helpers/index.js';

// const common = useCommonStore()
const app = useAppStore();
const user = useUserStore();

// const otherSocialChannels = computed(() => {
//   return common.socialChannelTypes
//     .filter((channel) => channel !== 'YouTube')
//     .filter((channel) => channel !== 'TikTok')
//     .filter((channel) => channel !== 'Instagram')
// })

const addCustomChannelForm = ref();
const customChannelPayload = ref({
  selectedChannel: null,
  url: null
});
const isCustomChannelFormValid = ref(false);

const customSocialChannels = computed(() => {
  return user.socialChannels
    .filter((channel) => channel !== 'YouTube')
    .filter((channel) => channel !== 'TikTok')
    .filter((channel) => channel !== 'Instagram');
});

const fakeYoutubeSocialConnects = [
  {
    id: 1,
    name: 'amazingJane',
    avatar: testSocialAvatar1,
    social: 'youtube'
  },
  {
    id: 2,
    name: 'awesomeMary',
    avatar: testSocialAvatar2,
    social: 'youtube'
  },
  {
    id: 3,
    name: 'awesomePerson',
    avatar: testSocialAvatar3,
    social: 'youtube'
  }
];

const fakeInstagramSocialConnects = [
  {
    id: 1,
    name: 'amazingGirl',
    avatar: testSocialAvatar4,
    social: 'instagram'
  },
  {
    id: 2,
    name: 'awesomeGirl',
    avatar: testSocialAvatar5,
    social: 'instagram'
  }
];

const fakeTiktokSocialConnects = [
  {
    id: 1,
    name: 'amazingPerson',
    avatar: testSocialAvatar1,
    social: 'tiktok'
  }
];

const addNewSocialChannelWithOAuth = (fieldType, channelType) => {
  user.connectUserChannelWithOAuth(fieldType, channelType);
};

const addCustomSocialChannel = (fieldType) => {
  user.addCustomSocialChannel(fieldType, customChannelPayload.value.selectedChannel, customChannelPayload.value.url);
};

const removeSocialChannel = (field, channelType) => {
  // user.removeCustomSocialChannel(fieldType, channelType)
};
</script>

<template>
  <div class="tw-max-w-[750px]">
    <headerPartial title="Creator Channels"></headerPartial>
  </div>

  <!-- <headerPartial title="Creator Channels"></headerPartial>
  <SectionPartial label="YouTube Channels" subtitle="Add your YouTube channels for better project sync.">
    <div class="d-flex justify-space-between align-start">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column">
          <template v-for="(socialConnect, index) in fakeYoutubeSocialConnects" :key="socialConnect.id">
            <SocialChannelCard :social-channel="socialConnect" :remove-social-channel="removeSocialChannel" />
          </template>
        </div>
      </div>
      <div class="d-flex justify-space-between align-center">
        <v-btn
          class="text-white"
          variant="flat"
          color="primary"
          @click="addNewSocialChannelWithOAuth('youtube', 'YouTube')"
          :loading="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'youtube'"
          :disabled="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'youtube'"
        >
          <template v-slot:prepend>
            <font-awesome-icon :icon="['fas', 'plus']" />
          </template>
          <span class="text-white"> Add Channel </span>
        </v-btn>
      </div>
    </div>
  </SectionPartial>
  <SectionPartial label="Instagram Channels" subtitle="Add your Instagram channels for better project sync.">
    <div class="d-flex justify-space-between align-start">
      <div class="d-flex flex-column">
        <template v-for="(socialConnect, index) in fakeInstagramSocialConnects" :key="socialConnect.id">
          <SocialChannelCard :social-channel="socialConnect" :remove-social-channel="removeSocialChannel" />
        </template>
      </div>
      <div class="d-flex justify-space-between align-center">
        <v-btn
          class="text-white"
          variant="flat"
          color="primary"
          @click="addNewSocialChannelWithOAuth('instagram', 'Instagram')"
          :loading="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'instagram'"
          :disabled="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'instagram'"
        >
          <template v-slot:prepend>
            <font-awesome-icon :icon="['fas', 'plus']" />
          </template>
          <span class="text-white"> Add Channel </span>
        </v-btn>
      </div>
    </div>
  </SectionPartial>
  <SectionPartial label="TikTok Channels" subtitle="Add your TikTok channels for better project sync.">
    <div class="d-flex justify-space-between align-start">
      <div class="d-flex flex-column">
        <template v-for="(socialConnect, index) in fakeTiktokSocialConnects" :key="socialConnect.id">
          <SocialChannelCard :social-channel="socialConnect" :remove-social-channel="removeSocialChannel" />
        </template>
      </div>
      <div class="d-flex justify-space-between">
        <v-btn
          class="text-white"
          variant="flat"
          color="primary"
          @click="addNewSocialChannelWithOAuth('tiktok', 'TikTok')"
          :loading="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'tiktok'"
          :disabled="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'tiktok'"
        >
          <template v-slot:prepend>
            <font-awesome-icon :icon="['fas', 'plus']" />
          </template>
          <span class="text-white"> Add Channel </span>
        </v-btn>
      </div>
    </div>
  </SectionPartial>
  <SectionPartial
    label="Create content on other channels?"
    :is-loading="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'custom-channel'"
  >
    <div class="d-flex flex-column mt-8">
      <div class="d-flex justify-space-between align-center">
        <v-form
          class="d-flex"
          ref="addCustomChannelForm"
          v-model="isCustomChannelFormValid"
          @submit.prevent="addCustomSocialChannel('custom-channel')"
        >
          <v-select
            label=""
            v-model="customChannelPayload.selectedChannel"
            placeholder="Select a platform"
            :items="otherSocialChannels"
            density="compact"
            variant="outlined"
            style="width: 193px"
          >
          </v-select>
          <v-text-field
            density="compact"
            variant="outlined"
            color="primary-blue"
            placeholder="url"
            class="rounded-0 ml-3 mr-5"
            style="width: 373px"
            v-model="customChannelPayload.url"
            :disabled="!customChannelPayload.selectedChannel || user.creatorChannelUpdate.isLoading"
            :rules="Helpers.getSocialChannelURLValidation(customChannelPayload.selectedChannel)"
          ></v-text-field>
          <div class="d-flex align-center" style="margin-top: -21px">
            <v-btn
              class="mr-3"
              variant="tonal"
              :disabled="
                !customChannelPayload.selectedChannel ||
                (user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'custom-channel')
              "
            >
              clear
            </v-btn>
            <v-btn
              class="flex-grow-1"
              :class="!(customChannelPayload.selectedChannel && customChannelPayload.url) ? '' : 'text-white'"
              :variant="!(customChannelPayload.selectedChannel && customChannelPayload.url) ? 'tonal' : 'flat'"
              dark
              :color="!(customChannelPayload.selectedChannel && customChannelPayload.url) ? '' : 'primary-teal'"
              type="submit"
              :loading="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'custom-channel'"
              :disabled="!(customChannelPayload.selectedChannel && customChannelPayload.url)"
            >
              <span :class="!(customChannelPayload.selectedChannel && customChannelPayload.url) ? '' : 'text-white'"> Save </span>
            </v-btn>
          </div>
        </v-form>
      </div>
      <div class="d-flex flex-column">
        <template v-for="customChannel in customSocialChannels" :key="customChannel.id">
          <v-hover v-slot="{ isHovering, props }" open-delay="30" close-delay="30">
            <div
              v-bind="props"
              class="d-flex align-center mb-6 px-1 py-1"
              :class="isHovering ? 'on-hover' : ''"
              style="border: 2px solid white; background: white; border-radius: 11px; cursor: pointer; box-shadow: 0px 3px 6px #00000029"
              :style="isHovering ? 'border: 2px solid;' : ''"
            >
              <div class="d-flex justify-space-between align-center" style="width: 100%">
                <div class="d-flex align-center">
                  <v-img
                    style="width: 32px"
                    class="rounded-full"
                    :src="Helpers.getSocialMediaIcon(customChannel.type)"
                    :lazy-src="Helpers.getSocialMediaIcon(customChannel.type)"
                    :alt="customChannel.type"
                  ></v-img>
                  <div class="font-weight-medium ml-3 mr-5" style="width: 350px; font-size: 0.8rem">
                    {{ customChannel.url }}
                  </div>
                </div>
                <div class="justify-end">
                  <v-btn
                    :color="isHovering ? 'error' : ''"
                    :variant="isHovering ? 'flat' : 'tonal'"
                    :disabled="user.creatorChannelUpdate.isLoading && user.creatorChannelUpdate.fieldType === 'custom-channel'"
                    type="submit"
                  >
                    Remove
                  </v-btn>
                </div>
              </div>
            </div>
          </v-hover>
        </template>
      </div>
    </div>
  </SectionPartial> -->
</template>

<style scoped></style>
